/* =====================================================================
   GALERIE « NOS PLATS EN PHOTO »
   La liste des photos est dans snippets/yamouna-plats.liquid
   - Sur mobile : « Tout télécharger » ouvre le menu de partage (Enregistrer les images)
   - Sur ordinateur : télécharge un .zip de toutes les photos
   ===================================================================== */
(function(){
  const PLATS = window.YAMOUNA_PLATS || [];
  const TXT = {
    fr:{title:"Nos plats en photo", all:"Tout télécharger", one:"Télécharger", close:"Fermer", wait:"Préparation…", count:"photos", prev:"Photo précédente", next:"Photo suivante", zip:"Photos-Le-Yamouna.zip"},
    en:{title:"Our dishes in pictures", all:"Download all", one:"Download", close:"Close", wait:"Preparing…", count:"photos", prev:"Previous photo", next:"Next photo", zip:"Le-Yamouna-Photos.zip"}
  };
  let L = "fr", cur = 0, dlg, blobs = {}, prefetching = null;
  const t = k => TXT[L][k];
  const name = p => (L==="en" && p.en) ? p.en : (p.fr || "");
  const alt = (p,i) => name(p) || (L==="en" ? "Le Yamouna dish, photo " : "Plat du Yamouna, photo ") + (i+1);
  const fileName = p => (p.file || p.fr || "photo").normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-z0-9]+/gi,"-").replace(/^-|-$/g,"") + ".jpg";
  const isTouch = matchMedia("(hover:none)").matches;

  function build(){
    dlg = document.createElement("dialog");
    dlg.className = "plats-dlg";
    dlg.setAttribute("aria-labelledby","plats-title");
    dlg.innerHTML = `
      <div class="plats-top">
        <div><h2 id="plats-title"></h2><p class="plats-count"></p></div>
        <div class="plats-actions">
          <button type="button" class="btn btn-primary btn-small" data-act="all"><svg aria-hidden="true"><use href="#i-dl"/></svg><span></span></button>
          <button type="button" class="plats-x" data-act="close"><svg aria-hidden="true"><use href="#i-close"/></svg></button>
        </div>
      </div>
      <ul class="plats-grid"></ul>
      <div class="plats-view" hidden>
        <figure><img alt=""><figcaption></figcaption></figure>
        <button type="button" class="plats-nav prev" data-act="prev"><svg aria-hidden="true"><use href="#i-prev"/></svg></button>
        <button type="button" class="plats-nav next" data-act="next"><svg aria-hidden="true"><use href="#i-next"/></svg></button>
        <div class="plats-view-bar">
          <button type="button" class="btn btn-ghost btn-small" data-act="back"><svg aria-hidden="true"><use href="#i-close"/></svg><span></span></button>
          <button type="button" class="btn btn-primary btn-small" data-act="one"><svg aria-hidden="true"><use href="#i-dl"/></svg><span></span></button>
        </div>
      </div>`;
    document.body.appendChild(dlg);
    dlg.querySelector(".plats-grid").innerHTML = PLATS.map((p,i)=>
      `<li><button type="button" data-i="${i}"><img src="${p.thumb}" alt="" loading="lazy" width="400" height="400"><span></span></button></li>`).join("");
    dlg.addEventListener("click", onClick);
    dlg.addEventListener("close", ()=>{ document.documentElement.classList.remove("no-scroll"); });
    dlg.addEventListener("keydown", e=>{
      if(dlg.querySelector(".plats-view").hidden) return;
      if(e.key==="ArrowLeft") show(cur-1);
      if(e.key==="ArrowRight") show(cur+1);
      if(e.key==="Escape"){ e.preventDefault(); back(); }
    });
    // glisser à gauche / à droite dans la visionneuse
    let x0 = null;
    const v = dlg.querySelector(".plats-view");
    v.addEventListener("touchstart", e=>{ x0 = e.touches[0].clientX; }, {passive:true});
    v.addEventListener("touchend", e=>{ if(x0===null) return; const dx = e.changedTouches[0].clientX - x0; if(Math.abs(dx)>50) show(cur + (dx<0?1:-1)); x0 = null; });
    texts();
  }

  function texts(){
    if(!dlg) return;
    dlg.querySelector("#plats-title").textContent = t("title");
    dlg.querySelector(".plats-count").textContent = PLATS.length + " " + t("count");
    dlg.querySelector('[data-act="all"] span').textContent = t("all");
    dlg.querySelector('[data-act="one"] span').textContent = t("one");
    dlg.querySelector('[data-act="back"] span').textContent = t("close");
    dlg.querySelector('[data-act="close"]').setAttribute("aria-label", t("close"));
    dlg.querySelector('[data-act="prev"]').setAttribute("aria-label", t("prev"));
    dlg.querySelector('[data-act="next"]').setAttribute("aria-label", t("next"));
    dlg.querySelectorAll(".plats-grid button").forEach(b=>{
      const i = +b.dataset.i, p = PLATS[i]; const sp = b.querySelector("span"); sp.textContent = name(p); sp.hidden = !name(p); b.setAttribute("aria-label", alt(p,i));
    });
    if(!dlg.querySelector(".plats-view").hidden) show(cur);
  }

  function open(){
    if(!dlg) build();
    document.documentElement.classList.add("no-scroll");
    dlg.querySelector(".plats-view").hidden = true;
    dlg.showModal();
    dlg.querySelector(".plats-grid").scrollTop = 0;
    if(isTouch && navigator.canShare) prefetchAll(); // prêt pour le partage en un geste
  }
  function show(i){
    cur = (i + PLATS.length) % PLATS.length;
    const p = PLATS[cur], v = dlg.querySelector(".plats-view");
    v.hidden = false;
    const img = v.querySelector("img"); img.src = p.full; img.alt = alt(p,cur);
    const fc = v.querySelector("figcaption"); fc.textContent = name(p) || ((cur+1) + " / " + PLATS.length);
  }
  function back(){ dlg.querySelector(".plats-view").hidden = true; }

  function getBlob(p){
    if(blobs[p.full]) return Promise.resolve(blobs[p.full]);
    return fetch(p.full, {mode:"cors"}).then(r=>{ if(!r.ok) throw 0; return r.blob(); }).then(b=>(blobs[p.full]=b));
  }
  function prefetchAll(){ return prefetching || (prefetching = Promise.all(PLATS.map(p=>getBlob(p).catch(()=>null)))); }
  function saveBlob(blob, fname){
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob); a.download = fname;
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(a.href), 4000);
  }
  function asFile(p){ const b = blobs[p.full]; return b ? new File([b], fileName(p), {type: b.type || "image/jpeg"}) : null; }

  async function downloadOne(){
    const p = PLATS[cur];
    try{
      if(isTouch && navigator.canShare){
        await getBlob(p);
        const f = asFile(p);
        if(f && navigator.canShare({files:[f]})){ await navigator.share({files:[f]}); return; }
      }
      saveBlob(await getBlob(p), fileName(p));
    }catch(e){ if(e && e.name==="AbortError") return; window.open(p.full, "_blank", "noopener"); }
  }

  function loadZipLib(){
    if(window.JSZip) return Promise.resolve(window.JSZip);
    return new Promise((res,rej)=>{ const s = document.createElement("script");
      s.src = "https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js";
      s.onload = ()=>res(window.JSZip); s.onerror = rej; document.head.appendChild(s); });
  }
  async function downloadAll(btn){
    const label = btn.querySelector("span"); const old = label.textContent;
    try{
      if(isTouch && navigator.canShare){
        const ready = PLATS.every(p=>blobs[p.full]);
        if(ready){
          const files = PLATS.map(asFile).filter(Boolean);
          if(navigator.canShare({files})){ await navigator.share({files}); return; }
        } else {
          label.textContent = t("wait"); btn.disabled = true;
          await prefetchAll();
          btn.disabled = false; label.textContent = old;
          const files = PLATS.map(asFile).filter(Boolean);
          if(files.length && navigator.canShare({files})){
            try{ await navigator.share({files}); return; }catch(e){ if(e.name==="AbortError") return; /* geste expiré : on passe au zip */ }
          }
        }
      }
      label.textContent = t("wait"); btn.disabled = true;
      const [JSZip] = await Promise.all([loadZipLib(), prefetchAll()]);
      const zip = new JSZip(); const used = {};
      PLATS.forEach(p=>{ const b = blobs[p.full]; if(!b) return;
        let n = fileName(p); if(used[n]){ n = n.replace(/\.jpg$/, "-"+(++used[n])+".jpg"); } else used[n] = 1;
        zip.file(n, b); });
      saveBlob(await zip.generateAsync({type:"blob"}), t("zip"));
    }catch(e){ if(!(e && e.name==="AbortError")) console.warn("[Yamouna] téléchargement des photos impossible", e); }
    finally{ btn.disabled = false; label.textContent = old; }
  }

  function onClick(e){
    if(e.target === dlg){ dlg.close(); return; }   // clic sur le fond
    const b = e.target.closest("button"); if(!b) return;
    if(b.dataset.i !== undefined) return show(+b.dataset.i);
    const a = b.dataset.act;
    if(a==="close") dlg.close();
    else if(a==="back") back();
    else if(a==="prev") show(cur-1);
    else if(a==="next") show(cur+1);
    else if(a==="one") downloadOne();
    else if(a==="all") downloadAll(b);
  }

  window.YamounaPlats = { open, lang(l){ L = TXT[l] ? l : "fr"; texts(); } };
  document.addEventListener("click", e=>{ if(e.target.closest("#platsBtn")){ e.preventDefault(); open(); } });
  if(!PLATS.length){ const b = document.getElementById("platsBtn"); if(b) b.hidden = true; }
})();
